import { render, staticRenderFns } from "./v-autogrow-field.vue?vue&type=template&id=8135b8b2&"
import script from "./v-autogrow-field.vue?vue&type=script&lang=js&"
export * from "./v-autogrow-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports